module.exports = __webpack_public_path__ + "assets/img/company-vr.8906af55.png";